<template>
  <v-card solo>
    <v-card-title>
      {{ chartTitle }}
    </v-card-title>
    <v-card-text>
      <div >
        <Bar :chart-data="chartData" :chart-options="chartOptions" :chart-id="chartId" :dataset-id-key="datasetIdKey"
          :plugins="plugins" :height="height"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);
ChartJS.defaults.font.family = 'IRANSans';

export default {
  name: "MaterialBarChartCard",
  components: { Bar },
  inheritAttrs: false,
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => { },
    },
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 500,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => { },
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    chartTitle: {
      default: "",
      type: String,
    },
  },
};
</script>

<style>
.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}
</style>